/**
 * 파일을 창 아무 데나 떨어뜨리면 브라우저가 그 파일을 열어 버려 입력하던 폼 내용이 통째로 날아간다.
 * 파일을 받는 영역(uploader · attachfield) 밖에서는 그 기본 동작을 막는다.
 *
 * 창에는 한 번만 걸고, 받는 영역의 선택자만 모아 둔다 — 영역마다 따로 걸면 서로의 영역을 막는다.
 */

const selectors = new Set();
let installed = false;

/** @param {string} selector 파일을 받는 영역 (예: '.uploader') */
export const guardWindowDrop = (selector) => {
  selectors.add(selector);

  if (installed) {
    return;
  }

  installed = true;

  ['dragover', 'drop'].forEach((type) => {
    window.addEventListener(type, (event) => {
      const inside = [...selectors].some((item) => event.target.closest?.(item));

      if (!inside) {
        event.preventDefault();
      }
    });
  });
};
